<template>
    <v-container>
        <v-row>
            <v-col
                    cols="12"
            >
                <p class="font-weight-bold mb-6 text-center display-2">Category {{ lang}}</p>
                <hr>
                <v-row>
                    <v-col
                            cols="6"
                            lg="3"
                            md="3"
                            sm="6"
                            xs="6"
                            v-for="(product,index) in products"
                            :key="index"

                    >
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/produto'+index"
                        >
                            <v-img
                                    class="white--text align-end"
                                    src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
                            >
                                <v-card-title>{{ product.name }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary">
                                <div>Ut gravida, metus sit amet sodales consequat, quam quam commodo libero, at gravida elit est ut nisi.</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    $9.99
                                </v-btn>
                                <v-btn
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        metaInfo () {
            return {
                title: 'Category'
            }
        },
        data () {
            return {
                lang: "en",
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
                ],
                email:false,
                customer:{
                    email:""
                },
                loading:{
                    login:false
                },
                products: [
                    {
                        name: 'Product 1',
                    },
                    {
                        name: 'Product 2',
                    },
                    {
                        name: 'Product 3',
                    },
                    {
                        name: 'Product 4',
                    },
                    {
                        name: 'Product 5',
                    },
                    {
                        name: 'Product 6',
                    },
                    {
                        name: 'Product 7',
                    },
                    {
                        name: 'Product 8',
                    },
                ],
            }
        },
        methods:{
            init() {
                console.log(this.lang);
                var  page = window.location.pathname.split('/');
                if(page[1] == 'pt' || page[1] == 'es'){
                    this.lang = page[1];
                }else{
                    this.lang = 'en';
                }
            }
        },
        mounted(){
            var self = this;
            setInterval(function(){
                    self.init();
                }, 1000
            );
        }
    }
</script>